export default {
  'User name': '用户名',
  'User nickname': '用户昵称',
  balance: '余额',
  'User ID': '用户ID',
  'Change balance': '变更余额',
  'Before change': '变更前',
  'After change': '变更后',
  remarks: '备注',
  'Current balance': '当前余额',
  'Change amount': '变动数额',
  'Please enter the balance change amount': '请输入余额变更数额',
  'Balance after change': '变更后余额',
  'Please enter change remarks / description': '请输入变更备注/说明',
  User: '用户'
}
